'use client'

import React from 'react'
import { ListBox, ListBoxItem, ListBoxProps } from 'react-aria-components'
import { cn } from '@/lib/utils'

interface CustomerListProps extends ListBoxProps<Customer> {
  customers: Customer[]
}

export const CustomerList = ({
  customers,
  className,
  ...restProps
}: CustomerListProps) => {
  return (
    <ListBox
      aria-label="Customers List"
      selectionMode="single"
      className={cn('flex flex-col gap-1 p-1', className)}
      selectionBehavior="toggle"
      items={customers}
      {...restProps}
    >
      {(customer) => (
        <ListBoxItem
          id={customer?.id}
          textValue={customer?.phone}
          value={customer}
          className="flex w-full items-center rounded-md border !border-gray-100 px-3 py-2 text-left shadow-card hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-800"
        >
          <span className="flex-grow text-sm font-medium">
            {customer?.name}
          </span>
          <span className="font-mono text-xs font-medium text-gray-500">
            {customer?.phone}
          </span>
        </ListBoxItem>
      )}
    </ListBox>
  )
}
